RivalIQ.apps.LandscapeSettings.module('views', function (views, App, Backbone, Marionette, $, _) {

    'use strict';

    views.Email = Marionette.ItemView.extend({
        ui: {
            remove: 'a'
        },
        events: {
            'click a': 'removeEmail'
        },
        tagName: 'tr',
        template: '#notificationEmailTemplate',
        getStateManager: function () {
            // landscape settings
            return RivalIQ.state.landscape;
        },
        removeEmail: function () {
            const me = this;

            const emailToRemove = me.model.get('email');

            const emailSettings = me.getStateManager().get('emailSettings');
            const additionalAddresses = emailSettings.additionalAddresses;
            const index = additionalAddresses.indexOf(emailToRemove);

            if (index >= 0) {
                additionalAddresses.splice(index, 1);

                // update central state
                me.getStateManager().set('emailSettings', emailSettings);

                // update local model
                const model = me.model;
                model.collection.remove(model);
            }

            return false;
        }
    });

});
